import React from 'react';
import { FaPhone } from 'react-icons/fa';
import { CONTACT, phoneHref } from '../constants/contact';
import './FloatingPhoneCTA.css';

const FloatingPhoneCTA = () => (
  <a
    href={phoneHref}
    className="floating-phone-cta"
    aria-label={`Call NX Auto Care at ${CONTACT.phone}`}
  >
    <span className="floating-phone-icon-wrap">
      <FaPhone aria-hidden />
    </span>
    <span className="floating-phone-number">{CONTACT.phone}</span>
  </a>
);

export default FloatingPhoneCTA;
